import React, { Component } from 'react';
import _ from 'lodash';

import Permission from '../../components/Permission';
import Loading from '../../components/Loading';
import CampusStore from '../../stores/CampusStore';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { documentNumberFormatter, thaiDateFormatter, dashFormatter } from '../../utils/bootstrapTableFormatters';
import { MergeAttributes } from '../../components/FlatData';
import SimpleModal from '../../components/SimpleModal';

import NewCampusPage from '../../components/settings/NewCampusPage';
import EditCampusPage from '../../components/settings/EditCampusPage';

export default class CampusPage extends Component {
  constructor(props){
    super(props)

    this.state = {
      create_campus: {},
      edit_campus: {},
      isDataFetched: false,
      campuses: []
    }

    this.loadData = this.loadData.bind(this);
    this.actionsFormatter = this.actionsFormatter.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleCloseAndReloadData = this.handleCloseAndReloadData.bind(this);
  }

  componentDidMount(){
    if (!Permission.isAdmin()) {
      window.location.href = '/documents/mydoc';
    }else{
      this.loadData();
    }
  }

  loadData(){
    CampusStore.request({}).then((resp)=>{
      const campuses = _.get(resp.data, 'data', []);
      this.setState({
        campuses: campuses
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  _setTableOption(){ 
    if(this.state.isDataFetched){
      return "ไม่มีข้อมูล";
    }else{
      return <Loading />
    }
  }

  handleDelete(id){
    if (!window.confirm('ยืนยันการลบวิทยาเขต')) { return }
    
    CampusStore.request({
      id: id,
      method: 'delete'
    }).then(()=>{
      this.loadData();
    })
  }

  actionsFormatter(cell, row) {
    return (
      <div>
        <button className='btn btn-sm btn-primary mr-2' onClick={this.onEdit.bind(this, row)}>แก้ไข</button>
        <button className='btn btn-sm btn-danger' onClick={this.handleDelete.bind(this, cell)}>ลบ</button>
      </div>
    )
  }

  onEdit(campus){
    console.log('campus ==>', campus)
    this.setState({edit_campus: campus});
  }

  onCreate(){
    this.setState({ create_campus: {code: '', name: '', url: ''} });
  }

  onClose(){
    this.setState({ create_campus: {}, edit_campus: {} });
  }

  handleCloseAndReloadData(){
    console.log('onClose')
    this.setState({ create_campus: {}, edit_campus: {} }, this.loadData());
  }

  render(){
    const options = {
      sizePerPageList: [],
      sizePerPage: 20,
      noDataText: this._setTableOption()
    };
    var data = [];
    if (!_.isEmpty(this.state.campuses)){
      data = MergeAttributes(this.state.campuses);
    }

    return (
      <div className='campus-setting-page'>
        {Permission.isAdmin() && (
          <div>
            <div className='row form-group'>
              <div className='col-md-12'>
                <h3 className='font-weight-bold'>จัดการวิทยาเขต</h3>
              </div>
            </div>

            <div className='row form-group'>
              <div className='col-12 text-right'>
                <button className='btn btn-success' onClick={this.onCreate.bind(this)}>เพิ่มวิทยาเขต</button>
              </div>
            </div>

            <div className='rui-campus-table'>
              <BootstrapTable 
                data={data}
                search={ true }
                multiColumnSearch={ true }
                options={ options }
                striped
                hover
                pagination
                version='4'
                tableContainerClass={'table-sm'}
                trClassName='td-white-space-normal'>
                <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
                <TableHeaderColumn dataField='code'>รหัส</TableHeaderColumn>
                <TableHeaderColumn dataField='name' columnTitle dataSort={ true }>ชื่อ</TableHeaderColumn>
                <TableHeaderColumn dataField='url' columnTitle dataSort={ true }>URL</TableHeaderColumn>
                <TableHeaderColumn dataField='id' dataFormat={ this.actionsFormatter } columnClassName='text-center'></TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        )}

        {this.state.isDataFetched && !_.isEmpty(this.state.create_campus) && 
          <NewCampusPage 
            campus={this.state.create_campus} 
            handleCloseAndReloadData={this.handleCloseAndReloadData}
            onClose={this.onClose} />}

        {this.state.isDataFetched && !_.isEmpty(this.state.edit_campus) && 
          <EditCampusPage 
            campus={this.state.edit_campus} 
            handleCloseAndReloadData={this.handleCloseAndReloadData}
            onClose={this.onClose} />}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/settings/CampusPage.js